import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "draivn-help-center-demo-form row drv-my-4" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12" }

import { EMessagesKeys, type ISupportRequest } from "../../types";
import {
  emailValidator,
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";
import { computed, ref } from "vue";
import type { Input } from "draivn-ui-kit";
import { I18N_SERVICE_INJECTION_KEY } from "@/constants";
import { injector } from "@/services";


export default /*@__PURE__*/_defineComponent({
  __name: 'SupportForm',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const i18n = injector.injectFromRoot(I18N_SERVICE_INJECTION_KEY);

const { t } = i18n.global;

const props = __props;

// eslint-disable-next-line func-call-spacing
const emit = __emit;

const EMPTY_MODEL: Required<ISupportRequest> = {
  email: "",
  subject: "",
  description: "",
};

const model = computed<ISupportRequest>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: ISupportRequest) {
    emit("update:modelValue", value);
  },
});

const emailModel = computed<string>({
  get() {
    return props.modelValue?.email ?? EMPTY_MODEL.email;
  },
  set(value: string) {
    model.value = {
      ...model.value,
      email: value,
    };
  },
});

const subjectModel = computed<string>({
  get() {
    return props.modelValue?.subject ?? EMPTY_MODEL.subject;
  },
  set(value: string) {
    model.value = {
      ...model.value,
      subject: value,
    };
  },
});

const descriptionModel = computed<string>({
  get() {
    return props.modelValue?.description ?? EMPTY_MODEL.description;
  },
  set(value: string) {
    model.value = {
      ...model.value,
      description: value,
    };
  },
});

const emailControl = ref<typeof Input | null>(null);
const subjectControl = ref<typeof Input | null>(null);
const descriptionControl = ref<typeof Input | null>(null);

const hasFormError = computed<boolean>(() => {
  return (
    !emailModel.value ||
    emailControl.value?.hasError ||
    !subjectModel.value ||
    subjectControl.value?.hasError ||
    !descriptionModel.value ||
    descriptionControl.value?.hasError
  );
});
const hasError = computed<boolean>(() => {
  return hasFormError.value;
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_input = _resolveComponent("d-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_d_input, {
        ref_key: "emailControl",
        ref: emailControl,
        modelValue: emailModel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailModel).value = $event)),
        dense: "",
        outlined: "",
        autofocus: "",
        "lazy-rules": "",
        label: _ctx.$t(_unref(EMessagesKeys).CONTACT_SUPPORT_REQUEST_EMAIL_TITLE),
        rules: [
          _unref(requiredValidator)(
            _unref(t)(_unref(EMessagesKeys).VALIDATORS_REQUIRED_COMMON_MESSAGE)
          ),
          _unref(emailValidator)(_unref(t)(_unref(EMessagesKeys).VALIDATORS_EMAIL_COMMON_MESSAGE)),
        ]
      }, null, 8, ["modelValue", "label", "rules"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_d_input, {
        ref_key: "subjectControl",
        ref: subjectControl,
        modelValue: subjectModel.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subjectModel).value = $event)),
        dense: "",
        outlined: "",
        label: _ctx.$t(_unref(EMessagesKeys).CONTACT_SUPPORT_REQUEST_SUBJECT_TITLE),
        "lazy-rules": "",
        rules: [
          _unref(requiredValidator)(
            _unref(t)(_unref(EMessagesKeys).VALIDATORS_REQUIRED_COMMON_MESSAGE)
          ),
        ]
      }, null, 8, ["modelValue", "label", "rules"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_d_input, {
        ref_key: "descriptionControl",
        ref: descriptionControl,
        modelValue: descriptionModel.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((descriptionModel).value = $event)),
        class: "textarea-resize-none description-input",
        type: "textarea",
        dense: "",
        label: _ctx.$t(_unref(EMessagesKeys).CONTACT_SUPPORT_REQUEST_DESCRIPTION_TITLE),
        outlined: "",
        "lazy-rules": "",
        "hide-bottom-space": "",
        rules: [
          _unref(requiredValidator)(
            _unref(t)(_unref(EMessagesKeys).VALIDATORS_REQUIRED_COMMON_MESSAGE)
          ),
        ]
      }, null, 8, ["modelValue", "label", "rules"])
    ])
  ]))
}
}

})